import React from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Lock, Sparkles, ArrowRight, Check } from "lucide-react";

export function UpgradeBanner({ title, message, testid = "upgrade-banner" }) {
  const navigate = useNavigate();
  return (
    <div data-testid={testid} className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl border border-amber-500/30 bg-gradient-to-r from-amber-500/10 to-indigo-500/10 px-4 py-3">
      <div className="flex items-start gap-3 flex-1 min-w-0">
        <div className="w-9 h-9 rounded-xl bg-amber-500/15 border border-amber-400/40 grid place-items-center shrink-0"><Crown className="w-5 h-5 text-amber-300" /></div>
        <div className="min-w-0">
          <div className="font-semibold text-amber-100 text-sm">{title || "Limite del piano Base raggiunto"}</div>
          {message && <div className="text-[13px] text-slate-300/90 mt-0.5">{message}</div>}
        </div>
      </div>
      <button onClick={() => navigate("/admin/abbonamento")} data-testid={`${testid}-cta`}
        className="shrink-0 inline-flex items-center gap-1.5 bg-amber-500 hover:bg-amber-400 text-slate-900 font-semibold text-sm px-4 py-2 rounded-xl transition-colors">
        <Sparkles className="w-4 h-4" /> Passa a Pro <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}

export function ProLock({ feature, benefits }) {
  const navigate = useNavigate();
  const name = feature || "Questa funzione";
  return (
    <div data-testid="pro-lock" className="max-w-xl mx-auto mt-4 sm:mt-10 text-center bg-[#151C28] border border-slate-800 rounded-2xl p-8 fade-up">
      <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500/20 to-indigo-500/20 border border-amber-400/40 grid place-items-center mx-auto mb-4"><Lock className="w-8 h-8 text-amber-300" /></div>
      <h2 className="font-head font-bold text-2xl">{name} è una funzione <span className="text-amber-300">Pro</span></h2>
      <p className="text-slate-400 text-sm mt-2">Il tuo piano attuale è <b className="text-sky-300">Base</b>. Passa a <b className="text-indigo-300">Pro</b> per sbloccare questa e tutte le funzioni avanzate.</p>
      {Array.isArray(benefits) && benefits.length > 0 && (
        <ul className="text-left text-sm text-slate-300 mt-5 space-y-2 max-w-sm mx-auto">
          {benefits.map((b, i) => (
            <li key={i} className="flex items-center gap-2"><Check className="w-4 h-4 text-emerald-400 shrink-0" /> {b}</li>
          ))}
        </ul>
      )}
      <button onClick={() => navigate("/admin/abbonamento")} data-testid="pro-lock-cta"
        className="mt-6 inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-slate-900 font-semibold px-6 py-3 rounded-xl transition-colors">
        <Crown className="w-5 h-5" /> Passa a Pro
      </button>
    </div>
  );
}
